<template>
  <div class="day-select__container">
    <ul class="flex-1 weekdays">
      <li v-for="n in 7">{{day(n) | capitalize}}</li>
    </ul>
    <ul id="select_day" class="flex flex-1">
      <li @click.stop.prevent="setDay(1)" :class="{'isToday': isToday(date)}" >
        <div :class="[isMon ? 'active' : '']">{{date | dayOfWeek(1) | D }}</div>
      </li>
      <li @click.stop.prevent="setDay(2)">
        <div :class="[isTue ? 'active' : '']">{{date | dayOfWeek(2) | D }}</div>
      </li>
      <li @click.stop.prevent="setDay(3)">
        <div :class="[isWed ? 'active' : '']">{{date | dayOfWeek(3) | D }}</div>
      </li>
      <li @click.prevent="setDay(4)">
        <div :class="[isTur ? 'active' : '']">{{date | dayOfWeek(4) | D }}</div>
      </li>
      <li @click.prevent="setDay(5)">
        <div :class="[isFri ? 'active' : '']">{{date | dayOfWeek(5) | D }}</div>
      </li>
      <li @click.prevent="setDay(6)" v-if="weekends">
        <div :class="[isSat ? 'active' : '']">{{date | dayOfWeek(6) | D }}</div>
      </li>
      <li @click.prevent="setDay(7)" v-if="weekends">
        <div :class="[isSun ? 'active' : '']">{{date | dayOfWeek(7) | D }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
  import moment from 'moment' // eslint-disable-line no-unused-vars
  import config from '../../config' // eslint-disable-line no-unused-vars

  export default {
    props: {
      date: {
        default () {
          return config.now
        }
      },
      weekends: {
        default: true
      },
      locale: {
        default: window.USER && window.USER.locale ? window.USER.locale : 'en'
      }
    },
    computed: {
      isMon () {
        return this.isDay(1)
      },
      isTue () {
        return this.isDay(2)
      },
      isWed () {
        return this.isDay(3)
      },
      isTur () {
        return this.isDay(4)
      },
      isFri () {
        return this.isDay(5)
      },
      isSat () {
        return this.isDay(6)
      },
      isSun () {
        return this.isDay(7)
      }
    },
    methods: {
      isToday (date) {
        return moment(date).format('DD-MM-YYYY') === config.now.format('DD-MM-YYYY')
      },
      setDay (dayNum) {
        let newDate = moment(this.date).isoWeekday(dayNum)
        this.$emit('changed', newDate)
      },
      isDay (dayNum) {
        return moment(this.date).format('') === moment(this.date).isoWeekday(dayNum).format('')
      },
      day (weekday) {
        return moment(this.date).locale(this.locale).isoWeekday(weekday).format('ddd')
      }
    }
  }
</script>

<style scoped>

  @import '../../assets/css/variables.css';

  input,
  textarea,
  button,
  select,
  a {
    -webkit-tap-highlight-color: rgba(0,0,0,0);
  }

  .day-select__container {
    background: white;
  }

  .flex li {
    text-align: center;
    width: calc(100vw / 7);
    height:calc(100vw / 7);
    max-height: 50px;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    user-select: none;
  }

  .flex li > div {
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 35px;
    height: 35px;
    text-align: center;
  }

  #select_day {
    background: white;
    border-bottom: 1px solid #d9d9d9;
  }

  .active {
    background-color: var(--blue);
    border-radius: 50%;
    color: white;
  }
  .weekdays > li {
    text-align: center;
    width: calc(100vw / 7);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    user-select: none;
  }

  .weekdays {
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// DaySelect.vue?53388c8d